import {
  ApiResponse,
  ParcelCenterDownloadResponse,
  ParcelCenterUIResponse,
  ParcelCenterUISingleResponse,
} from "../../models/ApiResponse";
import {
  AddParcelCenterFdpMappingRequest,
  AddParcelCenterRequest,
  UpdateParcelCenterRequest,
} from "../../models/requestModels/parcelCenterRequest";
import { ParcelCenterResponse } from "../../models/responseModels/parcelCenterResponse";
import { axiosRequests } from "../axiosRequest";

export const ParcelCenterAgent = {
  getParcelCenterList: () =>
    axiosRequests.get<ParcelCenterUIResponse>(
      "/fdc-commandops/parcel-center/all"
    ),
  parcelCenterCsvDownload: (parcelCenterData: ParcelCenterResponse[]) =>
    axiosRequests.post<ParcelCenterDownloadResponse>(
      "/parcelCenter/DownloadCsv",
      parcelCenterData
    ),
  parcelCenterXlsxDownload: (parcelCenterData: ParcelCenterResponse[]) =>
    axiosRequests.postXlsx<Blob>(
      "/parcelCenter/DownloadXlsx",
      parcelCenterData
    ),
  addParcelCenter: (parcelCenterData: AddParcelCenterRequest) =>
    axiosRequests.post<ApiResponse>("/fdc-commandops/parcel-center/add", {
      ...parcelCenterData,
    }),
  updateParcelCenter: (parcelCenterData: UpdateParcelCenterRequest) =>
    axiosRequests.put<ApiResponse>(
      "/fdc-commandops/parcel-center/edit",
      parcelCenterData
    ),
  addParcelCenterFdpMapping: (
    parcelCenterFdpMappingData: AddParcelCenterFdpMappingRequest
  ) =>
    axiosRequests.post<ParcelCenterUISingleResponse>(
      "/fdc-commandops/parcel-center/add-fdp-parcel-center-mapping",
      {
        ...parcelCenterFdpMappingData,
      }
    ),
  editParcelCenterFdpMapping: (
    parcelCenterFdpMappingData: AddParcelCenterFdpMappingRequest
  ) =>
    axiosRequests.put<ParcelCenterUISingleResponse>(
      "/fdc-commandops/parcel-center/edit-fdp-parcel-center-mapping",
      {
        ...parcelCenterFdpMappingData,
      }
    ),
};
